var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"image-input",on:{"change":_vm.change}},[_c('input',{attrs:{"id":"file","type":"file","accept":"image/*"}})])}
var staticRenderFns = []

export { render, staticRenderFns }